var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSun = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "fill-stroke sun",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1568.5 -2644.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "fill",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(1574 2650)",
    fill: "#324655"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1577 2645)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 3,
    className: "stroke",
    fill: "none",
    stroke: "#324655",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    y2: 3,
    className: "stroke",
    transform: "translate(0 13)",
    fill: "none",
    stroke: "#324655",
    strokeLinecap: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1569 2653)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 3.077,
    className: "stroke",
    transform: "translate(16) rotate(90)",
    fill: "none",
    stroke: "#324655",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    y2: 3.077,
    className: "stroke",
    transform: "translate(3.077) rotate(90)",
    fill: "none",
    stroke: "#324655",
    strokeLinecap: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1582.657 2647.343) rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 3.077,
    className: "stroke",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#324655",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    y2: 3.077,
    className: "stroke",
    transform: "translate(0 12.923)",
    fill: "none",
    stroke: "#324655",
    strokeLinecap: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1571.343 2647.343) rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 3.077,
    className: "stroke",
    transform: "translate(16 0) rotate(90)",
    fill: "none",
    stroke: "#324655",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    y2: 3.077,
    className: "stroke",
    transform: "translate(3.077 0) rotate(90)",
    fill: "none",
    stroke: "#324655",
    strokeLinecap: "round",
    strokeWidth: 1
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSun, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sun.ff29d3bc.svg";
export { ForwardRef as ReactComponent };